import { RefreshCircleSolid } from 'iconoir-react';
import { PhotoButtonProps } from '@usacsmideo/types';

export const RetakePhoto = (props: PhotoButtonProps) => {
  return (
    <button onClick={props.setter}>
      <RefreshCircleSolid />
    </button>
  );
};
